import { render, staticRenderFns } from "./hangpai.vue?vue&type=template&id=72e6d691&scoped=true&"
import script from "./hangpai.vue?vue&type=script&lang=js&"
export * from "./hangpai.vue?vue&type=script&lang=js&"
import style0 from "./hangpai.vue?vue&type=style&index=0&id=72e6d691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e6d691",
  null
  
)

export default component.exports